import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_SERVICE_CONFIG_DETAIL',
        create: 'MARKET_SERVICE_CONFIG_CREATE',
        update: 'MARKET_SERVICE_CONFIG_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      var area_code = {
        prop: 'area_code',
        default: '',
        label: this.$t('area_code'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "area_code",
              "button": true
            },
            "model": {
              value: _this.form.model.area_code,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "area_code", $$v);
              }
            }
          });
        }
      };
      var currency = {
        prop: 'currency',
        default: '',
        label: this.$t('currency'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "currency",
              "button": true
            },
            "model": {
              value: _this.form.model.currency,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "currency", $$v);
              }
            }
          });
        }
      };
      /* const currency_unit = {
        prop: 'currency_unit',
        default: '',
        label: 'currency_unit',
        col: { span: 8 },
        render: () => <d2-dict-select name="currency_unit" vModel={ this.form.model.currency_unit } button/>
      } */

      var pick_up_login = {
        prop: 'pick_up_login',
        default: '',
        label: this.$t('pick_up_login'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "pick_up_login",
              "title": "pick things need login or not",
              "button": true
            },
            "model": {
              value: _this.form.model.pick_up_login,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pick_up_login", $$v);
              }
            }
          });
        }
      };
      this.form.model.pick_up_login_info = 'pick things need login or not';
      var pick_up_login_info = {
        prop: 'pick_up_login_info',
        default: '',
        label: 'pick_up_login_info：',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.pick_up_login_info,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pick_up_login_info", $$v);
              }
            }
          });
        }
      };
      var deliver_option = {
        prop: 'deliver_option',
        default: '',
        label: this.$t('deliver_option'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "deliver_option",
              "title": "deliver things need login or not",
              "button": true
            },
            "model": {
              value: _this.form.model.deliver_option,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "deliver_option", $$v);
              }
            }
          });
        }
      };
      this.form.model.register_method_info = 'register by mobile or email';
      var register_method = {
        prop: 'register_method',
        default: '',
        label: this.$t('register_method'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "register_method",
              "title": "register by mobile or email",
              "button": true
            },
            "model": {
              value: _this.form.model.register_method,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "register_method", $$v);
              }
            }
          });
        }
      };
      var register_status = {
        prop: 'register_status',
        default: '',
        label: this.$t('register_status'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "service_config_status",
              "title": "register can use or not",
              "button": true
            },
            "model": {
              value: _this.form.model.register_status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "register_status", $$v);
              }
            }
          });
        }
      };
      var register_method_info = {
        prop: 'register_method_info',
        default: '',
        label: this.$t('register_method_info'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.register_method_info,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "register_method_info", $$v);
              }
            }
          });
        }
      };
      this.form.model.screen_again_sms_info = 'screen need do again send sms or not';
      var screen_again_sms = {
        prop: 'screen_again_sms',
        default: '',
        label: this.$t('screen_again_sms'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "screen_again_sms",
              "title": "screen need do again send sms or not",
              "button": true
            },
            "model": {
              value: _this.form.model.screen_again_sms,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "screen_again_sms", $$v);
              }
            }
          });
        }
      };
      var screen_again_sms_info = {
        prop: 'screen_again_sms_info',
        default: '',
        label: this.$t('screen_again_sms_info'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.screen_again_sms_info,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "screen_again_sms_info", $$v);
              }
            }
          });
        }
      };
      var pick_code_english = {
        prop: 'pick_code_english',
        default: '',
        label: this.$t('pick_code_english'),
        col: {
          span: 12
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "pick_code_english",
              "title": "pickCode has english word or not",
              "button": true
            },
            "model": {
              value: _this.form.model.pick_code_english,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pick_code_english", $$v);
              }
            }
          });
        }
      };
      this.form.model.pick_code_english_info = 'pickCode has english word or not';
      var pick_code_english_info = {
        prop: 'pick_code_english_info',
        default: '',
        label: this.$t('pick_code_english_info'),
        col: {
          span: 12
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.pick_code_english_info,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pick_code_english_info", $$v);
              }
            }
          });
        }
      };
      var screen_upd_mobile = {
        prop: 'screen_upd_mobile',
        default: '',
        label: this.$t('screen_upd_mobile'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "screen_upd_mobile",
              "title": "screen can update mobile or not",
              "button": true
            },
            "model": {
              value: _this.form.model.screen_upd_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "screen_upd_mobile", $$v);
              }
            }
          });
        }
      };
      this.form.model.screen_upd_mobile_info = 'screen can update mobile or not';
      var screen_upd_mobile_info = {
        prop: 'screen_upd_mobile_info',
        default: '',
        label: this.$t('screen_upd_mobile_info'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.screen_upd_mobile_info,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "screen_upd_mobile_info", $$v);
              }
            }
          });
        }
      };
      var secret = {
        prop: 'secret',
        default: '',
        label: this.$t('secret'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.secret,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "secret", $$v);
              }
            }
          });
        }
      };
      var smsurl = {
        prop: 'sms_url',
        default: '',
        label: this.$t('sms_url'),
        col: {
          span: 24
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.sms_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_url", $$v);
              }
            }
          });
        }
      };
      var isencryption = {
        prop: 'is_encryption',
        default: '',
        label: this.$t('is_encryption'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "is_encryption",
              "button": true
            },
            "model": {
              value: _this.form.model.is_encryption,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "is_encryption", $$v);
              }
            }
          });
        }
      };
      var is_custom = {
        prop: 'is_custom',
        default: '',
        label: this.$t('is_custom'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "is_custom",
              "button": true
            },
            "model": {
              value: _this.form.model.is_custom,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "is_custom", $$v);
              }
            }
          });
        }
      };
      var fee_type = {
        prop: 'fee_type',
        default: '',
        label: this.$t('fee-type'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "fee_type",
              "button": true
            },
            "model": {
              value: _this.form.model.fee_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "fee_type", $$v);
              }
            }
          });
        }
      };
      var is_Admin = {
        prop: 'is_Admin',
        default: '',
        label: this.$t('is_Admin'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "is_Admin",
              "button": true
            },
            "model": {
              value: _this.form.model.is_Admin,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "is_Admin", $$v);
              }
            }
          });
        }
      };
      var admin_pwd = {
        prop: 'admin_pwd',
        default: '',
        label: this.$t('admin_pwd'),
        col: {
          span: 8
        },
        rule: {
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.admin_pwd,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_pwd", $$v);
              }
            }
          });
        }
      };
      var admin_account = {
        prop: 'admin_account',
        default: '',
        label: this.$t('admin_account'),
        col: {
          span: 8
        },
        rule: {
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.admin_account,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_account", $$v);
              }
            }
          });
        }
      };
      var free_time = {
        prop: 'free_time',
        default: '0',
        label: this.$t('free_time'),
        col: {
          span: 8
        },
        rule: {
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.free_time,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "free_time", $$v);
              }
            }
          });
        }
      };
      var http_basic_username = {
        prop: 'http_basic_username',
        default: '',
        label: this.$t('Http Basic Username'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.http_basic_username,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "http_basic_username", $$v);
              }
            }
          });
        }
      };
      var http_basic_password = {
        prop: 'http_basic_password',
        default: '',
        label: this.$t('Http Basic Password'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.http_basic_password,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "http_basic_password", $$v);
              }
            }
          });
        }
      };
      var messaging_service_sid = {
        prop: 'messaging_service_sid',
        default: '',
        label: this.$t('Messaging ServiceSid'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.messaging_service_sid,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "messaging_service_sid", $$v);
              }
            }
          });
        }
      };
      var http_status_callback = {
        prop: 'http_status_callback',
        default: '',
        label: this.$t('Http Status Callback'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true,
              "disabled": _this.mode == 'edit' ? true : false
            },
            "model": {
              value: _this.form.model.http_status_callback,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "http_status_callback", $$v);
              }
            }
          });
        }
      };
      var twilio_http_base_url = {
        prop: 'twilio_http_base_url',
        default: '',
        label: this.$t('Twilio Http Base Url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true,
              "disabled": _this.mode == 'edit' ? true : false
            },
            "model": {
              value: _this.form.model.twilio_http_base_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "twilio_http_base_url", $$v);
              }
            }
          });
        }
      };
      return [// {
      //   prop: 'market_id',
      //   default: '',
      //   label: 'market_id',
      //   col: { span: 8 },
      //   render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } custom stringify />
      // },
      {
        prop: 'market_mobile',
        default: this.market_mobile ? this.market_mobile : utils.cookies.get('phone'),
        label: this.$t('market_mobile'),
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this.form.model.market_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'service_type',
        default: '',
        label: this.$t('service_type'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "service_type",
              "button": true
            },
            "on": {
              "change": _this.onTypeChange
            },
            "model": {
              value: _this.form.model.service_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "service_type", $$v);
              }
            }
          });
        }
      }].concat(_toConsumableArray(this.form.model.service_type == 'system' ? [area_code, currency, admin_account, admin_pwd, pick_up_login, fee_type, is_Admin, free_time, pick_up_login_info, deliver_option, register_method, register_status, screen_again_sms, pick_code_english, screen_upd_mobile] : this.form.model.service_type == 'sms' ? [secret, smsurl, isencryption, is_custom] : this.form.model.service_type == 'sms_twilio' ? [http_basic_username, http_basic_password, messaging_service_sid, http_status_callback, twilio_http_base_url] : []), [
      /* {
        prop: 'service_config',
        default: '',
        label: 'service_config',
        col: { span: 8 },
        render: () => <el-input type="textarea" autosize vModel={ this.form.model.service_config } clearable/>
      }, */
      {
        prop: 'status',
        default: '',
        label: this.$t('status'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "service_config_status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }]);
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    market_mobile: function market_mobile() {
      return this.$route.query.market_mobile;
    },
    market_id: function market_id() {
      return this.$route.query.market_id;
    }
  },
  methods: {
    onTypeChange: function onTypeChange() {
      this.modelReload({
        pick: ['market_mobile', 'service_type', 'status']
      });
    },

    /**
     * @description 加载需要的字典数据
     */
    loadDict: function loadDict() {
      // 洗衣店
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  }
};